import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";

import { PaymentGateway } from "../../../components";
import { GeneralContext } from "../../../contexts/general.context";
import { PGTranscriptRequestContext } from "../../../contexts/PGTranscriptRequest";

export const PaymentModal = ({ onClose, modal }) => {
  const navigate = useNavigate();

  const {
    setSelectedFile,
    initializePaymentSchema,
    setInitializePaymentSchema,
  } = useContext(GeneralContext);

  const { pgTranscriptInfo, setPgTranscriptInfo, setCopyType } = useContext(
    PGTranscriptRequestContext
  );

  const config = {
    email: pgTranscriptInfo.destinationEmail,
  };

  const closeHandler = () => {
    onClose((prevStep) => prevStep - 1);
  };

  const handleSubmission = () => {
    navigate("/dashboard/home");

    //resetting transcript state logic
    setPgTranscriptInfo({});
    setCopyType();
    setSelectedFile("");
    setInitializePaymentSchema({});
  };


  return (
    <>
      <PaymentGateway
        onPayment={handleSubmission}
        onPrevious={closeHandler}
        config={config}
        modal={modal}
        initializePaymentObject={initializePaymentSchema}
      />
    </>
  );
};
